import { CompanyModel } from "./company.model";

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  PARTNER = 'PARTNER',
  CUSTOMER = 'CUSTOMER',
}

export enum photoType {
  PHOTO = 'PHOTO',
  LOGO = 'LOGO'
}

export class User {
  id: number;

  firstName: string;
  lastName: string;
  email: string;
  password: string;
  salt: string;
  technicianid: string
  admin: boolean

  phone_1: string | null;
  phone_2: string | null;
  address: string | null;
  postalCode: string | null;
  country: string | null;
  preferredTimezone: string | null;
  notificationTree: any

  urlPhoto: string | null;
  photo: any;
  uploadedFiles: any[];

  status: UserStatus;
  oldStatus: UserStatus | null;
  role: UserRole;
  subroles: any[];
  permissions: string[];

  token: string | null;
  expiresIn: Date | null;
  accountVerified: boolean;
  accountVerificationCode: string | null;
  recoveryCode: string | null;
  recoveryCodeValidUntil: Date | null;

  companyId: number | null;
  validatedById: number | null;

  company: CompanyModel | null;
  validateBy: User | null;

  lastLogin: Date | null;
  lastLogout: Date | null;
  validatedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
  hasActiveTask: boolean;
  use_products: boolean;


  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : 0;

    this.firstName = $obj && $obj.firstName ? $obj.firstName : "";
    this.lastName = $obj && $obj.lastName ? $obj.lastName : "";
    this.email = $obj && $obj.email ? $obj.email : '';
    this.password = $obj && $obj.password ? $obj.password : null;
    this.salt = $obj && $obj.salt ? $obj.salt : null;
    this.notificationTree = $obj && $obj.notificationTree ? $obj.notificationTree : null;

    this.phone_1 = $obj && $obj.phone_1 ? $obj.phone_1 : null;
    this.phone_2 = $obj && $obj.phone_1 ? $obj.phone_2 : null;
    this.address = $obj && $obj.address ? $obj.address : null;
    this.postalCode = $obj && $obj.postalCode ? $obj.postalCode : null;
    this.country = $obj && $obj.country ? $obj.country : null;
    this.preferredTimezone = $obj && $obj.preferredTimezone ? $obj.preferredTimezone : null;

    this.urlPhoto = $obj && $obj.urlPhoto ? $obj.urlPhoto : null;
    this.photo = $obj && $obj.photo ? $obj.photo : null;
    this.uploadedFiles = $obj && $obj.uploadedFiles ? $obj.uploadedFiles : [];

    this.status = $obj && $obj.status ? $obj.status : UserStatus.ACTIVE;
    this.oldStatus = $obj && $obj.oldStatus ? $obj.oldStatus : null;
    this.role = $obj && $obj.role ? $obj.role : UserRole.CUSTOMER;
    this.subroles = $obj && $obj.subroles ? $obj.subroles : [];
    this.permissions = $obj && $obj.permissions ? $obj.permissions : [];

    this.token = $obj && $obj.token ? $obj.token : null;
    this.expiresIn = $obj && $obj.expiresIn ? new Date($obj.expiresIn) : null;
    this.accountVerified = $obj && $obj.accountVerified ? $obj.accountVerified : false;
    this.accountVerificationCode = $obj && $obj.accountVerificationCode ? $obj.accountVerificationCode : null;
    this.recoveryCode = $obj && $obj.recoveryCode ? $obj.recoveryCode : null;
    this.recoveryCodeValidUntil = $obj && $obj.recoveryCodeValidUntil ? new Date($obj.recoveryCodeValidUntil) : null;

    this.companyId = $obj && $obj.companyId ? $obj.companyId : $obj && $obj.company ? $obj.company.id : null;
    this.validatedById = $obj && $obj.validatedById ? $obj.validatedById : $obj && $obj.validateBy ? $obj.validatedBy.id : null;

    this.company = $obj && $obj.company ? new CompanyModel($obj.company) : null;
    this.validateBy = $obj && $obj.validateBy ? new User($obj.validateBy) : null;

    this.lastLogin = $obj && $obj.lastLogin ? new Date($obj.lastLogin) : null;
    this.lastLogout = $obj && $obj.lastLogout ? new Date($obj.lastLogout) : null;
    this.validatedAt = $obj && $obj.validatedAt ? new Date($obj.validatedAt) : null;
    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
    this.hasActiveTask = $obj && $obj.hasActiveTask ? $obj.hasActiveTask : false;
    this.use_products = $obj && $obj.use_products === "1" ? true : false;
  }

  get isCustomer(): boolean { return this.role && this.role === UserRole.CUSTOMER ? true : false; }
  get isMember(): boolean { return this.role && this.role === UserRole.MEMBER ? true : false; }
  get isPartner(): boolean { return this.role && this.role === UserRole.PARTNER ? true : false; }
  get isAdmin(): boolean { return this.role && this.role === UserRole.ADMIN ? true : false; }
  get isCustomerOrPartner(): boolean { return this.role && (this.role === UserRole.CUSTOMER || this.role === UserRole.PARTNER) ? true : false; }
  get isActive(): boolean { return this.status === UserStatus.ACTIVE }
  get isInactive(): boolean { return this.status === UserStatus.INACTIVE }

  getName(language: string): string {
    let name = '';
    if (language === 'pt') name = `${this.firstName} ${this.lastName}`;
    else name = `${this.lastName} ${this.firstName}`;

    return name;
  };

  getInitials(language: string): string {
    let initials = '';
    if (language === 'pt') initials = initials.concat(this.firstName.charAt(0), this.lastName.charAt(0));
    else initials = initials.concat(this.lastName.charAt(0), this.firstName.charAt(0));

    return initials;
  };

  setByForm(form: any, photoHolder: any, companyId: number | null) {
    this.firstName = form.firstName;
    this.lastName = form.lastName;
    this.email = form.email;
    this.password = form.password;
    this.phone_1 = form.mobileNumber;
    this.phone_2 = !form.phoneNumber || form.phoneNumber === "" ? null : form.phoneNumber;
    this.address = form.address;
    this.postalCode = form.postalCode;
    this.country = !form.locality || form.locality === "" ? null : form.locality;
    this.role = form.userType;
    this.photo = photoHolder != null ? this.getBase64(photoHolder) : null;

    if (companyId) this.companyId = companyId;

    return this;
  }

  getBase64(file: any): any {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  }

  toAPI() {
    return {
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      password: this.password,
      phone_1: this.phone_1,
      phone_2: this.phone_2,
      address: this.address,
      postalCode: this.postalCode,
      country: this.country,
      role: this.role,
      picture: this.photo,
      companyId: this.companyId,
    };
  }

  toAPIByForm(form: any, photoHolder: any, companyId: number | null) {
    return {
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      password: form.password,
      phone_1: form.mobileNumber,
      phone_2: !form.phoneNumber || form.phoneNumber === "" ? null : form.phoneNumber,
      address: form.address,
      postalCode: form.postalCode,
      country: !form.locality || form.locality === "" ? null : form.locality,
      role: form.userType,
      picture: photoHolder,
      companyId: companyId,
      daysAvailable: +form.availableDays,
      daysAdditional: +form.additionalDays
    };
  }

  toGuestAPIByForm(userForm: any, companyForm: any, partnerForm: any, photoHolder: any, logoHolder: any) {
    return {
      isPartner: userForm.userType === UserRole.CUSTOMER ? false : true,
      user: {
        firstName: userForm.firstName,
        lastName: userForm.lastName,
        email: userForm.email,
        password: userForm.password,
        phone_1: userForm.mobileNumber,
        phone_2: !userForm.phoneNumber || userForm.phoneNumber === "" ? null : userForm.phoneNumber,
        address: userForm.address,
        postalCode: userForm.postalCode,
        country: !userForm.locality || userForm.locality === "" ? null : userForm.locality,
        role: userForm.userType,
      },
      company: {
        name: companyForm.name,
        email: companyForm.email,
        businessActivity: companyForm.businessActivity,
        phone1: companyForm.mobileNumber,
        phone2: !companyForm.phoneNumber || companyForm.phoneNumber == "" ? null : companyForm.phoneNumber,
        website: !companyForm.website || companyForm.website === '' ? null : companyForm.website,
        taxFileNumber: companyForm.taxFileNumber,
        country: !companyForm.locality || companyForm.locality == "" ? null : companyForm.locality,
        postalCode: companyForm.postalCode,
        address: companyForm.address,
        type: userForm.userType,
        partnerId: userForm.userType === UserRole.CUSTOMER ? partnerForm.partnerId : null
      },
      photo: photoHolder,
      logo: logoHolder,
    };
  }
}
